/**
 * Almacen donde el temporizador se persiste. Lo cumplen las clases estaticas
 * que heredan de BaseStorage.
 */
export interface TimerStorage {
    setObject(keyName: string, objData: unknown): void;
    getObject(keyName: string): { refreshTime?: string | number; refreshLast?: string | number } | null | undefined;
}

/**
 * Helper timer to handle refreshing.
 */
class RefreshTimer  {    
    /**
     * Unique name for storage.
     */
    name: string;
    /**
     * Last refresh timestamp, milliseconds.
     */
    refreshLast = 0;
    
    /**
     * Time to next refresh, seconds.
     */
    refreshTime = 0;

    /**
     * OJO - campo fantasma: no se asigna en ningun sitio, asi que formatLast()
     * siempre devuelve ''. Lo que se pretendia leer es refreshLast. No se
     * corrige aqui porque cambiaria la cadena de diagnostico que muestran
     * InitSessionScreen, TestInfo y el informe de error del menu.
     * @see UpdateService.getDebugInfo
     */
    lastChecked?: number;
        
    /**
     * Build refresh timer.
     */
    constructor(name = 'refresh_timer', refreshTime = 0, refreshLast = 0) {
      this.name = name;
      this.refreshTime = refreshTime;
      this.refreshLast = refreshLast;
    } 
    
    /**
     * Check refresh time, for services that need refreshing.
     */
    needsRefresh(): boolean {
      return this.refreshTime > 0 && Date.now() - this.refreshLast >  1000 * this.refreshTime;
    }
    
    /**
     * Sets last refresh time.
     */
    setRefreshLast(): this {
      this.refreshLast = Date.now();
      return this;
    }
    
    /**
     * Sets time to next refresh, seconds.
     */
    setRefreshTime(sTime: number): this {
      this.refreshTime = sTime;
      return this;
    }     
    
    /**
     * Sets last refresh and time interval for next refresh.
     */
    setRefreshNext(sTime: number): this {
      this.setRefreshLast();
      this.setRefreshTime(sTime);
      return this;
    }    
    
    /**
     * Format last refreshed time.
     *
     * @see lastChecked
     */
    formatLast(): string {
      return this.lastChecked ? (new Date(this.lastChecked)).toLocaleString() : '';
    }
    
    /**
     * Save to storage.
     */
    saveTo(storage: TimerStorage): this {
      storage.setObject(this.name, this);
      return this;
    }
    
    /**
     * Load from storage.
     */
    loadFrom(storage: TimerStorage): void {
      const timer = storage.getObject(this.name);
      if (timer) {
        this.refreshTime = parseInt(String(timer.refreshTime));
        this.refreshLast = parseInt(String(timer.refreshLast));
      }      
    }    
}

export default RefreshTimer;
